import { useEffect, useRef, useState } from "react";
import { checkAdmin } from "../../utils/jwtUtils";
import TabContent from "./TabContent";
import { fetchGroup } from "../../services/groupService";
import { TOKEN_KEY } from "../../constants/storageKey";

const Tabs = ({ student }) => {
  const [noteJury, setNoteJury] = useState([[], [], [], []]);
  const [activeTab, setActiveTab] = useState(null);
  const [juries, setJuries] = useState([]);
  const [allowedJuries, setAllowedJuries] = useState([]);

  const token = localStorage.getItem(TOKEN_KEY);
  const isAdmin = checkAdmin();
  const noteRef = useRef(prepareNoteJury(student.notes));

  useEffect(() => {
    setNoteJury(noteRef.current);
  }, []);

  useEffect(() => {
    noteRef.current = prepareNoteJury(student.notes);
    setNoteJury(noteRef.current);
  }, [student.id, student.notes]);

  useEffect(() => {
    setActiveTab(null);
  }, [student.group]);

  useEffect(() => {
    if (!isAdmin) {
      fetchGroup()
        .then((response) => {
          const juryList = [];
          Object.values(response.data).forEach((group) => {
            const batchId = group.id;
            group.juries.forEach((juryId) => {
              juryList.push({ batch_id: batchId, jury_id: juryId });
            });
          });
          setJuries(juryList);
        })
        .catch((error) => {
          console.error("Erreur de réseau:", error.message);
        });
    }
  }, [isAdmin, token]);

  function initAllowedJuries(juries, student) {
    return juries
      .filter((jury) => jury.batch_id === student.group)
      .map((jury) => jury.jury_id);
  }

  useEffect(() => {
    setAllowedJuries(initAllowedJuries(juries, student));
  }, [juries, student]);

  return (
    <div className="h-full bg-gray-100 mt-20">
      <div className="flex border-b justify-around">
        {noteJury.map((_, index) => {
          if (!isAdmin && !allowedJuries.includes(index + 1)) {
            return null;
          }

          return (
            <button
              key={index + 1}
              className={`cursor-pointer py-2 px-4 ${
                activeTab === index
                  ? "border border-black text-white bg-secondary-blue font-semibold w-full text-center"
                  : "border border-black text-black hover:text-white hover:bg-tertiary-blue w-full text-center"
              }`}
              onClick={() => setActiveTab(index)}
            >
              {`Jury ${index + 1}`}
            </button>
          );
        })}
      </div>

      {activeTab != null && (
        <div className="tab-content">
          <TabContent
            notes={noteJury[activeTab]}
            studentId={student.id}
            key={activeTab + 1}
          />
        </div>
      )}
    </div>
  );
};

export default Tabs;

function prepareNoteJury(notes) {
  const updatedNoteJury = [
    { module: 1, moduleName: "Poomsae 1", value: null, id: null, exist: false },
    { module: 2, moduleName: "Poomsae 2", value: null, id: null, exist: false },
    { module: 3, moduleName: "Kibons 1", value: null, id: null, exist: false },
    { module: 4, moduleName: "Kibons 2", value: null, id: null, exist: false },
    { module: 5, moduleName: "Kibons 3", value: null, id: null, exist: false },
    { module: 6, moduleName: "Kibons 4", value: null, id: null, exist: false },
    { module: 7, moduleName: "Kibons 5", value: null, id: null, exist: false },
    { module: 8, moduleName: "Kibons 6", value: null, id: null, exist: false },
    {
      module: 9,
      moduleName: "Han bon Kyorugui",
      value: null,
      id: null,
      exist: false,
    },
    {
      module: 10,
      moduleName: "Hoshinsoul",
      value: null,
      id: null,
      exist: false,
    },
    {
      module: 11,
      moduleName: "Kyorugui 1",
      value: null,
      id: null,
      exist: false,
    },
    {
      module: 12,
      moduleName: "Kyorugui 2",
      value: null,
      id: null,
      exist: false,
    },
    { module: 13, moduleName: "Kyokpa 1", value: null, id: null, exist: false },
    { module: 14, moduleName: "Kyokpa 2", value: null, id: null, exist: false },
    { module: 15, moduleName: "QCM", value: null, id: null, exist: false },
  ];

  notes.forEach((note) => {
    const index = note.module_id - 1;
    if (updatedNoteJury[index]) {
      updatedNoteJury[index] = {
        ...updatedNoteJury[index],
        value: note.value,
        id: note.id,
        exist: true,
      };
    }
  });

  const groupedNoteJury = [
    updatedNoteJury.slice(0, 8),
    updatedNoteJury.slice(8, 10),
    updatedNoteJury.slice(10, 12),
    updatedNoteJury.slice(12, 15),
  ];
  return groupedNoteJury;
}
